import React, { useState, useEffect } from "react";
import { X, Send } from "lucide-react";

const Commentbox = ({ onClose, comments, addComment, emiNo, month }) => {
  const [comment, setComment] = useState("");
  const [closing, setClosing] = useState(false);

  const handleClose = () => {
    setClosing(true);
    setTimeout(() => {
      setComment("");
      onClose();
    }, 180);
  };

  const handleAddComment = () => {
    if (!comment.trim()) return;
    addComment({
      text: comment.trim(),
      user: "Current User",
      date: new Date().toLocaleString(),
    });
    setComment("");
    handleClose();
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.45)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        padding: 20,
        animation: "backdropIn 0.2s ease",
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) handleClose();
      }}
    >
      <style>{`
        @keyframes backdropIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes modalIn { from { opacity: 0; transform: scale(0.92) translateY(12px); } to { opacity: 1; transform: scale(1) translateY(0); } }
        @keyframes modalOut { from { opacity: 1; transform: scale(1) translateY(0); } to { opacity: 0; transform: scale(0.92) translateY(12px); } }
      `}</style>

      <div
        style={{
          width: "100%",
          maxWidth: 500,
          background: "#fff",
          borderRadius: 20,
          padding: 24,
          // fontFamily: "Inter, sans-serif",
          animation: closing
            ? "modalOut 0.18s ease forwards"
            : "modalIn 0.22s cubic-bezier(0.34,1.36,0.64,1)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 18,
          }}
        >
          <h2
            style={{
              margin: 0,
              fontSize: "18px",
              fontWeight: 600,
              color: "#101828",
            }}
          >
            Add Comment - {emiNo} EMI ({month})
          </h2>
          <button
            onClick={handleClose}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: 4,
              borderRadius: "50%",
              display: "flex",
            }}
          >
            <X size={18} color="#99A1AF" />
          </button>
        </div>

        <textarea
          autoFocus
          placeholder="Enter your comment..."
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              handleAddComment();
            }
          }}
          style={{
            width: "100%",
            minHeight: 110,
            padding: "12px 14px",
            borderRadius: 10,
            border: "0.8px solid #D1D5DC",
            fontSize: 14,
            outline: "none",
            resize: "none",
            marginBottom: 16,
            fontFamily: "inherit",
            color: "#111",
          }}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 10,
            marginBottom: 20,
          }}
        >
          <button
            onClick={handleClose}
            style={{
              padding: "9px 18px",
              borderRadius: 10,
              background: "#F3F4F6",
              border: "1px solid #E5E7EB",
              fontWeight: 500,
              cursor: "pointer",
              color: "#364153",
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleAddComment}
            style={{
              padding: "9px 18px",
              borderRadius: 10,
              background: "#155DFC",
              border: "none",
              color: "#fff",
              fontWeight: 500,
              display: "flex",
              alignItems: "center",
              gap: 6,
              cursor: "pointer",
              whiteSpace: "nowrap",
            }}
          >
            <Send size={15} /> Add Comment
          </button>
        </div>

        {/* Previous Comments */}
        <div style={{ borderTop: "1px solid #E5E7EB", paddingTop: 14 }}>
          <p
            style={{
              fontSize: 13,
              fontWeight: 500,
              color: "#6B7280",
              marginBottom: 10,
            }}
          >
            Previous Comments ({comments.length})
          </p>
          <div style={{ maxHeight: 130, overflowY: "auto" }}>
            {comments.length === 0 ? (
              <p style={{ fontSize: 13, color: "#9CA3AF" }}>No comments yet</p>
            ) : (
              comments.map((c, i) => (
                <div
                  key={i}
                  style={{
                    background: "#F9FAFB",
                    border: "1px solid #F1F5F9",
                    borderRadius: 10,
                    padding: "10px 12px",
                    marginBottom: 8,
                  }}
                >
                  <div
                    style={{ fontSize: 14, color: "#111827", marginBottom: 3 }}
                  >
                    {c.text}
                  </div>
                  <div style={{ fontSize: 12, color: "#6B7280" }}>
                    {c.user} • {c.date}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Commentbox;
